import React from 'react'

import { Helmet } from 'react-helmet'

import './page.css'

const Page = () => {
  return (
    <div className="page-container">
      <Helmet>
        <title>404 - Page Not Found</title>
        <meta property="og:title" content="404 - Page Not Found" />
      </Helmet>
      <h1>404 - Page Not Found</h1>
      <p>Oops! The page you're looking for doesn't exist.</p>
      <a href="/">Go back to homepage</a>
    </div>
  )
}

export default Page
